import React from "react";
import { useLocation } from "react-router-dom";
import ToolBar from "./index/ToolBar";
import TabBar from "./index/TabBar";
import SideBar from "./index/SideBar";
import styles from "./index/index.module.scss"

const Index = ({ children }) => {
  const title = children.props.pageTitle.title;
  const sidebar = children.props.pageTitle.sidebar;
  const sidebarItems = children.props.sidebarItems;

  const location = useLocation();

  return (

    <div className={"col-12 indexContents"}>
      <div className={`container-fluid p-24`}>
        <div className={'topBar'}>
          <ToolBar dataHeader={title}/>
          <TabBar/>
        </div>
        <div className={"row mainIndexContent"}>
          {
            new URLSearchParams(location.search).get('view') !== 'side-by-side' ? (
              sidebar && <SideBar sidebarItems={sidebarItems} />
            ) : (
                <SideBar sidebarItems={sidebarItems} mode={'sideBySide'} />
            )
          }

          <div className={`${styles.MainDashboardContainer} ${['/process-explorer','/variant-explorer','/process-compare'].includes(location.pathname) && styles.GridBackground}`}>
            { children }
          </div>
        </div>
      </div>
    </div>
  )
};

export default Index;
